import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResetPasswordForm, ResetPasswordFormData } from 'components/auth';
import { WAREHOUSE_ROUTES } from 'constants/routes';
import { WarehouseAuthContainer } from '../components/WarehouseAuthContainer';
import { InvalidResetToken } from './InvalidResetToken';
import { useWarehouseResetPassword } from './useWarehouseResetPassword';

export const WarehouseResetPassword: React.FC = () => {
  const navigate = useNavigate();
  const { onFinish, contextHolder, form, invalidToken, isLoading } = useWarehouseResetPassword();

  const handleBackToLogin = () => {
    navigate(WAREHOUSE_ROUTES.warehouseSignIn);
  };

  const handleFormSubmit = (values: ResetPasswordFormData) => {
    onFinish(values);
  };

  const customPasswordValidation = async (value: string) => {
    if (!value || value.trim().length >= 12) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('Password must be at least 12 characters long.'));
  };

  if (invalidToken) {
    return (
      <WarehouseAuthContainer
        title="Reset Password"
        bottomLinkText="Back to Sign In"
        bottomLinkAction={handleBackToLogin}
      >
        <InvalidResetToken />
      </WarehouseAuthContainer>
    );
  }

  return (
    <>
      {contextHolder}
      <WarehouseAuthContainer
        title="Set up a Password"
        description="Please create a new password for your account."
        bottomLinkText="Back to Sign In"
        bottomLinkAction={handleBackToLogin}
      >
        <ResetPasswordForm
          form={form}
          onFinish={handleFormSubmit}
          loading={isLoading}
          submitButtonText="Set up Password"
          showBackToLogin={false} // Using container's bottom link instead
          customPasswordValidation={customPasswordValidation}
        />
      </WarehouseAuthContainer>
    </>
  );
};
